    window.initLegalisationWidget = function(index, $form) {
        index = index ? 1 : index;
        let $addRowButton = $form.find('.form__see-more');
        let $removeRowButton = $form.find('.form__see-more');
        let $wrapper = $form.find('.country-wrapper').first();
        let $container = $form.find('.country-container').first();

        $addRowButton.click(function () {
            if ($form.find('.country-wrapper').length >= 4) {
                return;
            }
            index++;
            let $clone = $wrapper.clone().hide();
            let $select = $clone.find('select').not('.legalisation-passport-select').first();
            $select.val('');
            $select.attr('name', $select.prop('name').replace('[0]', '[' + index + ']'));
            $select.parents('label').first().contents().filter(function () {
                return this.nodeType == 3;
            }).remove();
            $clone.find('.remove-country-row').first().removeClass('d-none');
            $clone.find('.document-origin label').first().addClass('d-none');
            $clone.appendTo($container).show('fast');
        });
    }
